import store from "@/store";

const loadQuestionData = (id: string) => {
  const data = store.state.allQuestions.find(item => item._id === id);
  return data;
};

export default loadQuestionData;
